import { tyreBrandListQuerySchema, tyreSizeListQuerySchema } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listTyreBrands, listTyreSizes } from '../tyres.api';

interface TyreFilterOptions {
  brands: string[];
  sizes: string[];
}

/**
 * The brand and size names for the register's column filters, fetched whole: the catalogues are short and a filter
 * opens with its choices. Names, not ids, because the list query filters on them. Empty until loaded.
 */
export function useTyreFilterOptions(): TyreFilterOptions {
  const [options, setOptions] = useState<TyreFilterOptions>({ brands: [], sizes: [] });

  useEffect(() => {
    let cancelled = false;
    Promise.all([listTyreBrands(tyreBrandListQuerySchema.parse({ pageSize: 100 })), listTyreSizes(tyreSizeListQuerySchema.parse({ pageSize: 100 }))])
      .then(([brands, sizes]) => !cancelled && setOptions({ brands: brands.items.map((brand) => brand.name), sizes: sizes.items.map((size) => size.name) }))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
